/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Trial_ActivateInputs */

const en_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate Account`)
};

const fr_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le compte`)
};

const de_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto aktivieren`)
};

const it_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva account`)
};

const ru_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активировать аккаунт`)
};

const es_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar cuenta`)
};

const zh_cn2_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活账户`)
};

const ja_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを有効化`)
};

const hi_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता सक्रिय करें`)
};

const pt_pt2_dialogue_list_export_trial_activate = /** @type {(inputs: Dialogue_List_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar conta`)
};

/**
* | output |
* | --- |
* | "Activate Account" |
*
* @param {Dialogue_List_Export_Trial_ActivateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_trial_activate = /** @type {((inputs?: Dialogue_List_Export_Trial_ActivateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Trial_ActivateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_trial_activate(inputs)
	if (locale === "de") return de_dialogue_list_export_trial_activate(inputs)
	if (locale === "it") return it_dialogue_list_export_trial_activate(inputs)
	if (locale === "ru") return ru_dialogue_list_export_trial_activate(inputs)
	if (locale === "es") return es_dialogue_list_export_trial_activate(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_trial_activate(inputs)
	if (locale === "ja") return ja_dialogue_list_export_trial_activate(inputs)
	if (locale === "hi") return hi_dialogue_list_export_trial_activate(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_trial_activate(inputs)
	return en_dialogue_list_export_trial_activate(inputs)
});